import { IncentiveCampaignRankingType } from 'domains/loyalty.d';

export function isPositionTextVisible(
  incentiveCampaignRanking: IncentiveCampaignRankingType | undefined
): boolean {
  if (!incentiveCampaignRanking?.position || incentiveCampaignRanking?.position <= 0) {
    return false;
  }

  const hasPositionText =
    incentiveCampaignRanking.position &&
    incentiveCampaignRanking.position <= incentiveCampaignRanking.limit;

  return !!hasPositionText;
}
